import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardWrapper, CardHeader, CardSection } from 'foundations-components/transitional/components/Card';
import { H4 } from 'foundations-components/transitional/components/H4';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Text } from 'foundations-components/components/Text';
import { RANGE_TYPES } from 'reporting-data/constants/dateRangeTypes';
import { ContentObjectTypes, useContentObjectType } from 'content-management-data-lib';
import useMabPastExperiments from '../../hooks/useMabPastExperiments';
import MABPastVariantsTable from './MABPastVariantsTable';
import useContentId from '../../hooks/useContentId';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MABPastExperimentCard = ({
  mabPastExperimentInfo
}) => {
  const {
    deletedAt,
    startedAt
  } = mabPastExperimentInfo.mabExperiment;
  const endDate = I18n.moment(deletedAt).format('LL');
  const startDate = I18n.moment(startedAt).format('LL');
  return /*#__PURE__*/_jsxs(CardWrapper, {
    compact: true,
    defaultExpanded: false,
    expandable: true,
    children: [/*#__PURE__*/_jsx(CardHeader, {
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "page-details-ui.testResults.personalizationResults.mabPastExperimentCard.experimentDuration",
            options: {
              endDate,
              startDate
            }
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.testResults.personalizationResults.mabPastExperimentCard.header.submissionsPerPageview"
        })]
      }),
      titleSize: "extra-small"
    }), /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsx(MABPastVariantsTable, {
        dateRange: {
          endDate: I18n.moment(deletedAt).format('YYYY-MM-DD'),
          rangeType: RANGE_TYPES.CUSTOM,
          startDate: I18n.moment(startedAt).format('YYYY-MM-DD')
        },
        mabVariantsMap: mabPastExperimentInfo.mabVariantsMap,
        variantIds: Object.keys(mabPastExperimentInfo.mabVariantsMap),
        mabMetric: mabPastExperimentInfo.mabExperiment.metric
      })
    })]
  });
};
const MABPastExperiments = () => {
  const contentId = useContentId();
  const {
    contentObjectType
  } = useContentObjectType();
  const {
    mabPastExperiments,
    mabPastExperimentsRequestLoading
  } = useMabPastExperiments({
    contentId,
    isLandingPage: contentObjectType === ContentObjectTypes.LANDING_PAGE
  });
  if (mabPastExperimentsRequestLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.testResults.personalizationResults.mabPastExperiments.loadingLabel"
      }),
      layout: "centered",
      showLabel: true
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.testResults.personalizationResults.mabPastExperiments.title"
      })
    }), mabPastExperiments.map((mabPastExperiment, index) => /*#__PURE__*/_jsx(MABPastExperimentCard, {
      mabPastExperimentInfo: mabPastExperiment
    }, `past-experiment-${index}`))]
  });
};
export default MABPastExperiments;